<template>
    <div class="event club-event"
           :id="`club-${club.id}`"
        @click="openClub(club.id, 'club')"
         :class="{'online': club.isOnline, 'was-online': club.wasRecentlyOnline == true}">
        <div class="img" :style="{'background': `url(${club.photo_orig}) no-repeat center / cover`}">
          <div class="guide-details club-title">
            <div class="title">
              {{ club.title }}
            </div>
          </div>
        </div>
        <div class="details">
            <div class="participants">
                <div class="participant"
                     v-if="member.membershipStatus === 'host' || member.membershipStatus === 'member'"
                     v-for="member in members.slice(0, isMobile ? 2 : 3)"
                    :class="{'is-deleted': !!member.deleted_at}"
                    :style="!member.deleted_at && {'background': prepareMember(member)}">
                </div>
                <div class="participant" v-if="showAdditionalMembersCount"><span>+{{ membersCount }}</span></div>

                <div v-if="club.user_id === currentUserId && !!club.has_new_applicants" class="notificated-icon"></div>
            </div>
            <div class="small-details">
                <svg style="margin-left:20px;" v-if="club.is_private || invited || accepted" width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5 9H16.25V6.5C16.25 3.05 13.45 0.25 10 0.25C6.55 0.25 3.75 3.05 3.75 6.5V9H2.5C1.125 9 0 10.125 0 11.5V24C0 25.375 1.125 26.5 2.5 26.5H17.5C18.875 26.5 20 25.375 20 24V11.5C20 10.125 18.875 9 17.5 9ZM10 20.25C8.625 20.25 7.5 19.125 7.5 17.75C7.5 16.375 8.625 15.25 10 15.25C11.375 15.25 12.5 16.375 12.5 17.75C12.5 19.125 11.375 20.25 10 20.25ZM6.25 9V6.5C6.25 4.425 7.925 2.75 10 2.75C12.075 2.75 13.75 4.425 13.75 6.5V9H6.25Z" fill="#9D9D9D"/>
                </svg>
            </div>
        </div>
      <button v-if="!invited"
              type="button"
             class="btn notranslate"
            :class="membershipActionBtnClass"
       @click.stop="updateMembership({ clubId: club.id })"
         :disabled="membershipActionDisabled">
        {{ membershipActionText }}
      </button>
      <button v-if="invited && !accepted"
              type="button"
             class="btn darker decline notranslate"
             style="right: 88px;"
             :title="trans('clubs.decline')"
       @click.stop="declineInvite({ eventId: club.id })">
      </button>
      <button v-if="invited && !accepted"
              type="button"
             class="btn accept notranslate"
            :class="membershipActionBtnClass"
            :title="trans('clubs.accept')"
       @click.stop="acceptInvite({ eventId: club.id })">
      </button>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    import auth from '@general/lib/auth';
    import clubsModule from '@clubs/module/store/type';

    export default {
        data(){
          return {
            currentUserId: auth.getUserId(),
          };
        },
        mixins: [
	        require('@general/lib/mixin').default,
	        require('@general/lib/mixin-clubs').default,
		    ],
        props: ['club', 'invited', 'accepted'],
        created() {
          Vue.set(this.$store.state.clubsInfo, this.club.id, this.club)
        },
        computed: {
            ...mapGetters({
                membershipClubsRequests: clubsModule.getters.membershipClubsRequests,
            }),
            members() {
                return this.club.members.filter(member => !member.blocked);
            },
            membersCount() {
                return this.isMobile ? this.club.members_count - 2 : this.club.members_count - 3;
            },
            showAdditionalMembersCount(){
              return this.isMobile ? this.club.members_count > 2 : this.club.members_count > 3;
            },
            clubInfo() {
              return this.$store.state.clubsInfo[this.club.id] ?? this.club;
            }
        },
        methods: {
            ...mapActions({
              toggleClubLike: clubsModule.actions.clubs.like
            }),
            declineInvite(data) {
              this.declineClubInvitation(data);
              this.showSuccessNotification('Invitation successfully declined')
              // this.openClub(data.clubId, 'club');
              this.$store.dispatch('loadCurrentUserInfo');
              setTimeout(function(){
                app.$emit('reload-clubs')
              }, 750)
            },
            acceptInvite(data) {
              let self = this;
              let callback = function(){
                self.showSuccessNotification('Invitation successfully accepted')
                // this.openClub(data.clubId, 'club');
                self.$store.dispatch('loadCurrentUserInfo');
                setTimeout(function(){
                  app.$emit('reload-clubs')
                }, 750)
              }
              this.acceptClubInvitation(data, callback);
            },
            prepareMember(member) {
                const photo = member.photo_small;
                if (photo != null) {
                    return `url(${photo}) no-repeat center / cover`;
                } else {
                  return 'url("/assets/img/default_180x180.jpg") center / cover';
                }
            }
        }
    }
</script>
